// 峰会议程 6月13日
export const SUMMIT_DAY_3 = {
  title: '6月13日',
  day: 'DAY 3',
  host: '主会场',
  report: '第一报告厅',
  content: [
    {
      time: '9:00-12:10',
      title: '开源大模型分论坛',
      content: '这里汇聚中国大模型领域专家，包括工业界和学术界的主流玩家；这里探讨大语言模型的最新技术和应用。致力于成为全球领先的大语言模型交流平台，为业内人士提供最新的技术资讯、最深入的技术解析和最实用的应用指南。我们热诚欢迎您的加入，共同推动AI技术的前沿发展！',
      schedule: '主题日程（拟定）',
      guest: '演讲嘉宾（拟邀）',
      scheduleList: [
        {
          time: '9:00-9:10',
          content: [
            '**领导致辞**',
          ],
        },
        {
          time: '9:10-9:30',
          content: [
            '**开源协作下一代数字经济核心基础设施**',
            '**谭中意**  TOC主席',
          ],
        },
        {
          time: '9:30-9:50',
          content: [
            '**大模型的机遇与挑战**',
            '**徐琦**  上海人工智能协会副秘书长',
          ],
        },
        {
          time: '9:50-10:10',
          content: [
            '**大模型基础创新和应用享**',
            '**聂礼强**  哈工大计算机学院执行院长',
          ],
        },
        {
          time: '10:10-10:40',
          content: [
            '**从千亿模型 GLM-130B 到 ChatGLM 的开源尝试**',
            '**东昱晓**  清华大学计算机系助理教授',
          ],
        },
        {
          time: '10:40-10:55',
          content: [
            '**深度学习平台飞桨的大模型训练能力**',
            '**张军**  百度飞桨框架产品负责人',
          ],
        },
        {
          time: '10:55-11:10',
          content: [
            '**通义千问模型及服务**',
            '**林俊旸**  达摩院-通义千问团队-高级算法专家',
          ],
        },
        {
          time: '11:10-11:25',
          content: [
            '**昇思MindSpore超大规模AI实践**',
            '**金小贤**  华为MindSpore资深架构师',
          ],
        },
        {
          time: '11:25-11:40',
          content: [
            '**星脉：面向AI大模型的高性能无损算力网络**',
            '**李宝嘉**  腾讯数据中心网络架构师',
          ],
        },
        {
          time: '11:40-11:55',
          content: [
            '**开放共享，赋能创新：深圳数据交易所共建开源生态圈**',
            '**王腾**  深圳数据交易所',
          ],
        },
        {
          time: '11:55-12:10',
          content: [
            '**支撑企业级生成式 AI 的算力技术和国产化生态**',
            '**卢冕**  第四范式资深系统架构师',
          ],
        },
      ],
      peopleImage: 'https://res.oafimg.cn/-/baac877dfce4cc25/output.jpg',
      producerCounts: 1,
    },
    {
      time: '14:00-18:00',
      title: '云原生分论坛',
      content: '云原生技术发展至今，越来越多企业基于云原生构建面向未来的创新服务，IDC 报告显示，2023 年企业云原生应用占比将超过 80%，全球云原生产业领域迎来新阶段，新挑战，新机遇。',
      schedule: '主题日程（拟定）',
      guest: '演讲嘉宾（拟邀）',
      scheduleList: [
        { time: '14:00-14:05', content: ['**主持人开场**'] },
        { time: '14:05-14:15', content: ['**领导致辞**'] },
        {
          time: '14:15-14:30',
          content: ['**开放原子开源基金会云原生工作委员会工作设想**', '**胡春明**  北京航空航天大学 软件学院院长'],
        },
        {
          time: '14:30-14:45',
          content: ['**云原生时代，以开源赋能数字化转型**', '**邓明昆**  华为云开源业务总经理'],
        },
        {
          time: '14:45-15:05',
          content: ['**云原生技术在教学与科研中的应用实践**', '**沃天宇**  北京航空航天大学软件学院 副教授 '],
        },
        {
          time: '15:05-15:25',
          content: [
            '**中国移动算力网络的云原生探索实践**',
            '**陈燕军**  中国移动研究院网络与IT技术研究所 开源专家、LF Edge Akraino技术委员会委员',
          ],
        },
        {
          time: '15:25-15:45',
          content: ['**eBPF在滴滴云原生场景的落地实践**', '**张同浩**  滴滴系统软件负责人'],
        },
        {
          time: '15:45-16:05',
          content: [
            '**云原生 AI 加速人工智能工程化落地创新**',
            '**张凯**  阿里云智能云原生应用平台AI大数据方向负责人、Fluid 开源社区联合发起人',
          ],
        },
        {
          time: '16:05-16:25',
          content: ['**Sermant开源社区加速云原生微服务治理技术朝无代理架构的演进**', '**杨奕**  华为云技术规划专家'],
        },
        {
          time: '16:25-16:45',
          content: ['**腾讯大规模云原生计算平台构建**', '**陈显鹭**  腾讯星辰算力平台技术专家'],
        },
        {
          time: '16:45-17:05',
          content: ['**基于云原生的异构算力复用框架**', '**李孟轩**  第四范式异构算力虚拟化负责人 '],
        },
        {
          time: '17:05-17:25',
          content: ['**Kuasar，云原生场景全覆盖的多沙箱容器运行时**', '**冯绍宝**  华为云容器运行时架构师'],
        },
        {
          time: '17:25-17:45',
          content: ['**云原生的数据零信任安全开源建设**', '**程力**  南京飓风引擎信息技术有限公司CEO'],
        },
        {
          time: '17:45-18:00',
          content: ['**NGINX那么强大，为什么还需要 OpenNJet ？**', '**单雷**  通明智云应用引擎部门产品总监'],
        },
      ],
      peopleImage: 'https://res.oafimg.cn/-/089127adeb0e5f83/output.jpg',
      producerCounts: 3,
    },
  ],

  branch: [
    {
      divide: '分会场1',
      day: 'DAY 3',
      report: '会议室AB',
      content: [
        {
          time: '9:00-11:35',
          title: '软硬协同开源分论坛',
          content: '英特尔一直践行开源开放的理念， 积极推动全球开源社区建设， 我们全球19000名软件工程师参与了100多个开源项目，贡献、管理、维护着300多个社区. 在Linux Kernel 和Kubernetes 等重要领域是杰出的贡献者。英特尔分论坛将围绕OS, Cloud, AI三个方向介绍英特尔在开源领域的贡献以及领先技术。',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '9:00-9:05', content: ['**领导致辞**'] },
            {
              time: '9:05-9:35',
              content: ['**英特尔基础软件开放生态合作**',
                '**杨继国** 英特尔公司软件与先进技术事业部开源技术总监，龙蜥社区理事OpenCloud OS社区副理事长',
                '**尚旭春** 龙蜥社区Intel Arch SIG maintainer，阿里云开发工程师',
              ],
            },
            {
              time: '9:35-10:05',
              content: [
                '**加速迈入云原生时代-英特尔携手合作伙伴的创新与实践**',
                '**丁建峰** 英特尔云计算软件研发经理 ',
                '**神秘嘉宾**',
              ],
            },
            {
              time: '10:05-10:35',
              content: [
                '**Celadon加速安卓在英特尔架构上的产品创新**',
                '**刘秉伟**  英特尔软件与先进技术事业部高级系统软件总监',
              ],
            },
            {
              time: '10:35-11:05',
              content: [
                '**面向边缘计算的人工智能产品创新**',
                '**张宇** 英特尔公司高级首席 A 工程师、网络与边缘事业部中国区首席技术官、边缘计算产业联盟测试床工作组主席',
              ],
            },
            {
              time: '11:05-11:35',
              content: [
                '**ACRN虚拟化技术: 应对软件定义入式解决方案面临的挑战**',
                '**张宇** 英特尔软件架构师',
                '**任慰** OpenEuler嵌入式负责人',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/b7cc66006f250fe6/output.jpg',
          producerCounts: 0,
        },
        {
          time: '14:00-17:30',
          title: '开源教育与人才分论坛',
          content: '开放开源作为一种创新协作机制，在科研和教育、产教融合和人才培养方面，有着独特显著的优势。本论坛将聚集产学研用多位专家、教师、开源产业实践者，集中探讨前沿思想和一线实践。',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '14:00-14:05', content: ['**领导致辞**'] },
            {
              time: '14:05-14:10',
              content: ['**开放科学与开源教育**', '**赵硕** 中国科学院大学教育基金会秘书长'],
            },
            {
              time: '14:10-14:20',
              content: [
                '**《龙蜥社区人才培养计划启动仪式》**',
                '**冯冠霖**  开放原子开源基金会秘书长',
                '**赵硕**  中国科学院大学教育基金会秘书长',
                '**尹刚**  中国开源软件推进联盟副秘书长，头歌教研中心主任',
                '**马涛**  阿里云研究员，龙蜥社区理事长',
                '**朱建忠**  统信软件副总经理，龙蜥社区副理事长',
                '**张东**  浪潮信息高级副总裁，龙蜥社区理事',
              ],
            },
            {
              time: '14:20-14:45',
              content: ['**开源人才发展体系和评价方法**', '**王伟**  华东师范大学数据科学与工程学院教授'],
            },
            {
              time: '14:45-15:20',
              content: [
                '**工程教育与开源结合的模式探索**',
                '**杜辉**  软通动力集团高级教学总监、软通教育研究院副院长',
              ],
            },
            {
              time: '15:20-15:45',
              content: ['**一生一芯计划实践经验与教训**', '**王尤**  北京开源芯片研究院“一生一芯”人才培养计划项目主管'],
            },
            {
              time: '15:45-16:10',
              content: ['**openEuler的教育和人才培养实践**', '**邓晖龙**  欧拉基础软件服务总监'],
            },
            {
              time: '16:10-16:35',
              content: ['**开源数字化赋能计算机应用工程教育**', '**杨威**  东软教育研究院人工智能产品研发中心主任'],
            },
            { time: '16:35-17:00', content: ['**开源方式助力信息科技课标校本化**', '**向金** 开放原子开源基金会开源大师兄(待更名)项目主席'] },
            { time: '17:00-17:25', content: ['**开源技术教育与包容性社会**', '**詹娜** 上海芥梧科技包容性设计与科技实验室导师'] },
          ],
          peopleImage: 'https://res.oafimg.cn/-/e79b4a8c85b3fa5a/output.jpg',
          producerCounts: 1,
        },
      ],
    },
    {
      divide: '分会场2',
      day: 'DAY 3',
      report: '会议室C',
      content: [
        {
          time: '9:30-12:00',
          title: 'OSPO分论坛',
          content: 'OSPO论坛聚焦开源理论、开源项目管理，以及组织内部开源文化建设，旨在分享开源项目管理和运营经验，探讨组织内部开源人才成长以及开源项目未来发展方向，促进开源社区的合作和创新。',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '9:30-9:35',
              content: [
                '**主持人开场**',
              ],
            },
            {
              time: '9:35-9:55',
              content: [
                '**待定**',
                '**郭晧**  开放原子开源基金会业务发展部资深业务发展顾问',
              ],
            },
            {
              time: '9:55-10:15',
              content: [
                '**万物有序：开源世界的秩序建立和维系**',
                '**李建盛**  「开源之道」发起人及主创、LF APAC 开源布道者团队主席',
              ],
            },
            {
              time: '10:15-10:35',
              content: [
                '**润和软件OSPO顶层设计与实践**',
                '**刘洋**  江苏润和软件股份有限公司副总裁',
              ],
            },
            {
              time: '10:35-10:55',
              content: [
                '**开源项目的生命周期旅程**',
                '**刘洁**  华为开源战略专家',
              ],
            },
            {
              time: '10:55-11:15',
              content: [
                '**从OSPOer的角度看企业开源**',
                '**钟燕清**  微众银行开源管理办公室负责人',
              ],
            },
            {
              time: '11:15-12:00',
              content: [
                '**圆桌论坛**',
                '**开源与程序员职业发展**',
                '**主持人：李圳虎**',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/a5dce2f53961677b/output.jpg',
          producerCounts: 1,
        },
        {
          time: '14:00-17:30',
          title: 'TOC面对面',
          content: '开放原子开源基金会TOC（技术监督委员会）为基金会的开源项目提供技术指导，本次分论坛邀请TOC成员和导师集体亮相，介绍TOC工作职责、相关原则、导师辅导的项目等，更有TOC成员闪电演讲和圆桌讨论等精彩环节。',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '14:00-14:05', content: ['**主持人开场**'] },
            {
              time: '14:05-14:20',
              content: ['**TOC核心职能分享**', '**郑伟波**  浪潮数字企业技术有限公司 副总经理兼CTO'],
            },
            {
              time: '14:20-14:35',
              content: ['**TOC导师工作介绍**', '**谭中意**  开放原子开源基金会TOC主席'],
            },
            {
              time: '14:35-14:40',
              content: ['**开源深度学习框架发展趋势**', '**张军**  百度飞桨框架产品负责人'],
            },
            {
              time: '14:40-14:45',
              content: ['**汽车开源相关**', '**覃左言**  小米汽车自动驾驶车载系统技术负责人'],
            },
            {
              time: '14:45-14:50',
              content: ['**开源区块链技术发展趋势**', '**尚璇**  杭州趣链科技有限公司研发总监'],
            },
            {
              time: '14:50-14:55',
              content: ['**AIGC企业应用开发开源趋势**', '**韩鹏**  中软国际AIGC研究院副院长'],
            },
            { time: '14:55-15:00', content: ['**开源操作系统的发展展望**', '**张磊**  统信软件 CTO'] },
            {
              time: '15:00-15:05',
              content: ['**云原生serverless相关**', '**马涛**  阿里云研究员，龙蜥操作系统开源社区理事长'],
            },
            {
              time: '15:05-15:10',
              content: ['**机器人开源的现状与未来**', '**李远威**  深开鸿开源首席架构师'],
            },
            { time: '15:10-16:00', content: ['**Panel： AI大模型的开源发展路径**'] },
            { time: '16:00-16:50', content: ['**Panel：工控软件走向开源**'] },
            { time: '16:50-17:40', content: ['**Panel： 开源治理与孵化导师如何开展**'] },
          ],
          peopleImage: 'https://res.oafimg.cn/-/486a2d9117fd82f8/output.jpg',
          producerCounts: 1,
        },
      ],
    },
    {
      divide: '分会场3',
      day: 'DAY 3',
      report: '会议室DE',
      content: [
        {
          time: '9:00-11:40',
          title: '区块链分论坛',
          content: '随着全球Web3浪潮经由数字藏品、元宇宙等实现落地，区块链在“信息互联网”转向“价值互联网”中的重要作用进一步得到认可。在数字经济蓬勃发展、数据成为重要生产要素的时代，区块链已经不仅仅是一项技术、一种工具，更是一种思维方式和一类商业模式。区块链论坛特别邀请高校教授、行业专家、企业代表齐聚一堂、畅所欲言，规划行业未来发展蓝图。',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '9:30-9:40',
              content: ['**主持人开场**'],
            },
            { time: '9:40-9:50', content: [
              '**领导致辞**',
            ] },
            {
              time: '9:50-10:05',
              content: [
                '**主题演讲1**',
                '**陈钟** 北京大学区块链研究中心 主任',
              ],
            },
            {
              time: '10:05-10:20',
              content: ['**区块链构建价值互联网基础设施**', '**肖伟**  百度杰出科学家兼区块链总经理'],
            },
            {
              time: '10:20-10:35',
              content: ['**共筑数字的信任——联通链技术研发及工程实践**', '**谢云龙**  联通数科数据智能事业部区块链创新应用部总经理'],
            },
            {
              time: '10:35-10:50',
              content: ['**「区块链+隐私计算」赋能数据要素流通**', '**刘欣**  杭州趣链科技数据网格部产品总监'],
            },
            {
              time: '10:50-11:05',
              content: ['**招行区块链云服务探索与实践**', '**姬长伟**  招商银行信息技术部高级架构师'],
            },
            {
              time: '11:05-11:40',
              content: [
                '**圆桌讨论：《开源区块链的下一个十年》**',
                '**种法辉** 国家工业信息安全发展研究中心软件所新兴技术研究部主任',
                '**荆博** 百度区块链技术负责人',
                '**尚璇** 杭州趣链科技有限公司研发总监 ',
                '**潘东** 盛见科技CEO',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/a39b3eb4109d79ca/output.jpg',
          producerCounts: 1,
        },
        {
          time: '13:30-17:30',
          title: '开放原子校源行分论坛',
          content: '论坛以“聚缘于校、开源共行”为主题，邀请知名高校、优秀开源社团代表，开源大使和社区专家，头部科技企业于6月13日汇聚一堂，共话开源创新人才培育，推动科技教育普惠。',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '13:30-13:35',
              content: ['**主持人开场**'],
            },
            {
              time: '13:35-13:50',
              content: ['**开放原子校源行发展规划与展望**',
                '**刘京娟**'],
            },
            {
              time: '13:50-14:30',
              content: [
                '**腾讯犀牛鸟开源人才计划与实践**',
                '**赵跃** 腾讯产学合作总监 腾讯开源办公室成员',
                '**长安链开源课程的设计与实践**',
                '**范围** 腾讯云区块链资深运营',
              ],
            },
            {
              time: '14:30-16:10',
              content: [
                '**高校教师分享开源教育**',
                '**深化产教融合，培养开源人才(北京理工大学)**',
                '**吴长高**  北京理工大学信息技术创新学院院长',
                '**开源教育: 探索创新之路，共享知识力量(电子科技大学)**',
                '**朱国斌**  电子科技大学信息与软件工程学院副院长',
                '**高校开源实践-兰州大学开源俱乐部介绍(兰州大学)**',
                '**刘新**  兰州大学开源软件与实时系统教育部工程研究中心博士',
                '**智慧农业领域开源人才的培养探索与应用(内蒙古农业大学)**',
                '**付学良** 内蒙古农业大学计算机科学与技术系教授、博士生导师',
                '**高校开源人才生态建设探索(深圳技术大学 )**',
                '**李蒙** 深圳技术大学大数据与互联网学院计算机系主任，副教授',
              ],
            },
            {
              time: '16:10-17:20',
              content: [
                '**高校学生分享开源经历**',
                '**开源社团成立和组织活动经验分享(北京邮电大学)**',
                '**梁超越** 北京邮电大学开放原子开源社团会长',
                '**方兴未艾的开源，一位北邮学子的校园布道见闻(北京邮电大学)**',
                '**王嘉树** 北京邮电大学开放原子开源社团成员',
                '**拥抱开放原子:探索中北大学驱动全球数字经济的开源创新之路(中北大学)**',
                '**李明宇** 开放原子开源社团(中北大学)负责人',
                '**开源校园，共筑开源文化（北京交通大学）**',
                '**余健龙** 北京交通大学开放原子开源社团主席',
                '**开源之梦 学生的开源实践与愿景(金陵科技学院)**',
                '**夏金伟** 金陵科技学院软件工程学院学生代表',
                '**开放原子开源社团开源贡献经验分享（华中科技大学）**',
                '**邹亚龙** 社团学生负责人',
              ],
            },
            {
              time: '17:20-18:00',
              content: [
                '**校源行参与项目介绍**',
                '**OpenKona - 企业级的OpenJDK发行版**',
                '**江莎** OpenJDK Reviewer腾讯高级工程师 专注JDK安全领域',
                '**开源文化在高校推广的探索与实践**',
                '**蒋卫峰** 生态推广架构师',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/9ccbbad3b207e36c/output.jpg',
          producerCounts: 1,
        },
      ],
    },
    {
      divide: '分会场4',
      day: 'DAY 3',
      report: '信创园：经开区国家信创园会议中心9号楼一层会场',
      content: [
        {
          time: '9:00-12:00',
          title: '开源创新理论与实践分论坛',
          content: '开源社会存在的合理性是什么？国家开源创新体系如何构建？企业如何推动开源创新以获取竞争优势？开源创新理论与实践分论坛将邀请专家和实践者深入交流，以期形成理论，增强开源创新工作的主动性、前瞻性和有效性。',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '9:00-9:05', content: ['**主持人开场**'] },
            { time: '9:05-9:10', content: ['**领导致辞**'] },
            {
              time: '9:10-9:35',
              content: ['**开源创新赋能数字经济高质量发展**', '**隆云滔**  中科院科技战略咨询研究院 副研究员'],
            },
            {
              time: '9:35-10:00',
              content: ['**大模型开源项目的发展趋势与数字洞察**', '**韩凡宇**  华东师范大学数据科学与工程学院在读博士'],
            },
            {
              time: '10:00-10:25',
              content: ['**如何从0-1搭建起一个健康的开源社区**', '**李震宁**  麒麟软件有限公司 副总裁'],
            },
            {
              time: '10:25-10:50',
              content: ['**开源创新若干理论问题**', '**张国锋**  上海开源信息技术协会秘书长'],
            },
            {
              time: '10:50-11:15',
              content: ['**开源组织的管理与激励一基于价值网络的洞察**', '**赵生宇**  同济大学 开源博士'],
            },
            {
              time: '11:15-12:00',
              content: ['**圆桌讨论：《开源理论如何助力开源创新社会实践》**'],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/df83194b3e69c5d8/output.jpg',
          producerCounts: 1,
        },
        // {
        //   time: '14:00-17:30',
        //   title: '开源教育与人才分论坛',
        //   content: '开放开源作为一种创新协作机制，在科研和教育、产教融合和人才培养方面，有着独特显著的优势。本论坛将聚集产学研用多位专家、教师、开源产业实践者，集中探讨前沿思想和一线实践。',
        //   schedule: '主题日程（拟定）',
        //   guest: '演讲嘉宾（拟邀）',
        //   scheduleList: [
        //     { time: '14:00-14:10', content: ['**领导致辞**'] },
        //     {
        //       time: '14:10-14:20',
        //       content: ['**开放科学与开源教育**', '**赵硕** 中国科学院大学教育基金会秘书长']
        //     },
        //     {
        //       time: '14:15-14:25',
        //       content: [
        //         '**《龙蜥社区人才培养计划启动仪式》**',
        //         '**冯冠霖**  开放原子开源基金会秘书长',
        //         '**赵硕**  中国科学院大学教育基金会秘书长',
        //         '**尹刚**  中国开源软件推进联盟副秘书长，头歌教研中心主任',
        //         '**马涛**  阿里云研究员，龙蜥社区理事长',
        //         '**朱建忠**  统信软件副总经理，龙蜥社区副理事长',
        //         '**张东**  浪潮信息高级副总裁，龙蜥社区理事',
        //       ]
        //     },
        //     {
        //       time: '14:25-14:50',
        //       content: ['**开源人才发展体系和评价方法**', '**王伟**  华东师范大学数据科学与工程学院教授']
        //     },
        //     {
        //       time: '14:50-15:25',
        //       content: ['**工程教育与开源结合的模式探索**', '**杜辉**  软通教育研究院副院长，教育部工程认证专家']
        //     },
        //     {
        //       time: '15:25-15:50',
        //       content: ['**一生一芯计划实践经验与教训**', '**王尤**  北京开源芯片研究院“一生一芯”人才培养计划项目主管']
        //     },
        //     {
        //       time: '15:50-16:15',
        //       content: ['**openEuler的教育和人才培养实践**', '**邓晖龙**  欧拉基础软件服务总监']
        //     },
        //     {
        //       time: '16:15-16:40',
        //       content: ['**开源数字化赋能计算机应用工程教育**', '**杨威**  东软教育研究院人工智能产品研发中心主任']
        //     },
        //     { time: '16:40-17:05', content: ['**开源方式助力信息科技课标校本化**', '**向金** 开放原子开源基金会开源大师兄(待更名)项目主席'] },
        //     { time: '17:05-17:30', content: ['**开源技术教育与包容性社会**', '**詹娜** 上海芥梧科技包容性设计与科技实验室导师'] }
        //   ],
        //   peopleImage: 'https://res.oafimg.cn/-/e79b4a8c85b3fa5a/output.jpg',
        //   producerCounts: 1,
        // },
      ],
    },
  ],
}
